import React, { useState } from 'react';
import styled from 'styled-components';
import { MapPin, Phone, Mail, Clock, Facebook, Instagram, Send } from 'lucide-react';

// Styled Components
const SectionWrapper = styled.section`
  padding: 5rem 0;
  background: #111827;
  color: white;
  position: relative;
  overflow: hidden;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, #9333ea 0%, #ec4899 50%, #9333ea 100%);
  }
`;

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const ContactGrid = styled.div`
  display: grid;
  gap: 3rem;
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 4rem;
  }
`;

const ContactInfo = styled.div`
  animation: fadeInLeft 0.8s ease-out;
  @keyframes fadeInLeft {
    from { opacity: 0; transform: translateX(-30px); }
    to { opacity: 1; transform: translateX(0); }
  }
`;

const ContactTitle = styled.h2`
  font-size: 2.25rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
  background: linear-gradient(135deg, white 0%, #e9d5ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  @media (min-width: 640px) { font-size: 3rem; }
`;

const ContactSubtitle = styled.p`
  font-size: 1.25rem;
  color: #d1d5db;
  margin-bottom: 2.5rem;
  line-height: 1.6;
`;

const ContactDetails = styled.div`
  display: flex; flex-direction: column; gap: 1.5rem; margin-bottom: 2rem;
`;

const ContactItem = styled.div`
  display: flex; align-items: flex-start; gap: 1rem; padding: 1rem; border-radius: 0.75rem; transition: all 0.3s ease;
  &:hover { background: rgba(147, 51, 234, 0.1); transform: translateX(10px); }
`;

const ContactIcon = styled.div`
  width: 48px; height: 48px; background: linear-gradient(135deg, #9333ea 0%, #ec4899 100%); border-radius: 0.75rem;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  svg { width: 24px; height: 24px; color: white; }
`;

const ContactText = styled.div` flex: 1; `;
const ContactLabel = styled.p` font-weight: 600; margin-bottom: 0.25rem; color: white; `;
const ContactValue = styled.p` color: #d1d5db; font-size: 0.95rem; `;

const SocialLinks = styled.div` display: flex; gap: 1rem; margin-top: 2rem; `;
const SocialLink = styled.a`
  background: linear-gradient(135deg, #9333ea 0%, #ec4899 100%);
  width: 48px; height: 48px; border-radius: 50%; display: flex; align-items: center; justify-content: center;
  transition: all 0.3s ease; color: white;
  &:hover { transform: translateY(-5px); }
`;

const FormContainer = styled.div`
  background: #1f2937; border-radius: 1.5rem; padding: 2rem;
  border: 1px solid rgba(147, 51, 234, 0.2);
  animation: fadeInRight 0.8s ease-out;
  @keyframes fadeInRight { from { opacity: 0; transform: translateX(30px); } to { opacity: 1; transform: translateX(0); } }
`;

const FormTitle = styled.h3` font-size: 1.75rem; font-weight: bold; margin-bottom: 1.5rem; color: white; `;
const Form = styled.form` display: flex; flex-direction: column; gap: 1.25rem; `;
const FormGroup = styled.div` display: flex; flex-direction: column; gap: 0.5rem; `;
const Label = styled.label` font-size: 0.875rem; color: #d1d5db; `;
const Input = styled.input`
  width: 100%; padding: 0.875rem 1rem; border-radius: 0.75rem; background: #374151; border: 2px solid #4b5563; color: white;
  &:focus { outline: none; border-color: #9333ea; background: #475569; }
`;

const Select = styled.select`
  width: 100%; padding: 0.875rem 1rem; border-radius: 0.75rem; background: #374151; border: 2px solid #4b5563; color: white;
`;

const Textarea = styled.textarea`
  width: 100%; padding: 0.875rem 1rem; border-radius: 0.75rem; background: #374151; border: 2px solid #4b5563; color: white; min-height: 100px;
`;

const SubmitButton = styled.button`
  width: 100%; background: linear-gradient(135deg, #9333ea 0%, #ec4899 100%);
  padding: 1rem; border-radius: 0.75rem; font-weight: bold; color: white; border: none; cursor: pointer;
  display: flex; align-items: center; justify-content: center; gap: 0.5rem; transition: 0.3s;
  &:hover { transform: translateY(-2px); opacity: 0.9; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

const SuccessMessage = styled.div`
  background: rgba(16, 185, 129, 0.1); border: 1px solid #10b981; color: #6ee7b7;
  padding: 1rem; border-radius: 0.75rem; text-align: center; margin-bottom: 1rem;
`;

const ContactSection = () => {
  // THAY LINK WORKER CỦA BẠN VÀO ĐÂY
  const WORKER_URL = 'https://nk-salon-hair.germibays.workers.dev/api/booking';

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    service: '',
    datetime: '',
    message: ''
  });

  const [status, setStatus] = useState({ loading: false, success: false, error: null });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, success: false, error: null });

    try {
      const response = await fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus({ loading: false, success: true, error: null });
        setFormData({ name: '', phone: '', email: '', service: '', message: '' });
        setTimeout(() => setStatus(s => ({ ...s, success: false })), 5000);
      } else {
        throw new Error('Server bảo trì, vui lòng thử lại sau.');
      }
    } catch (err) {
      setStatus({ loading: false, success: false, error: err.message });
    }
  };

  return (
    <SectionWrapper id="liên hệ">
      <Container>
        <ContactGrid>
          <ContactInfo>
            <ContactTitle>Liên Hệ Với Chúng Tôi</ContactTitle>
            <ContactSubtitle>Đặt lịch hẹn hoặc tư vấn miễn phí ngay hôm nay</ContactSubtitle>
            <ContactDetails>
              <ContactItem><ContactIcon><MapPin /></ContactIcon>
                <ContactText>
                  <a target="_blank" href="https://maps.app.goo.gl/BKqDJYKf6JRbpCZv9" style={{ textDecoration: 'none', color: 'inherit' }}>
                  <ContactLabel>Địa chỉ</ContactLabel><ContactValue>43/2C Bà Điểm 5, Bà Điểm, Thành phố Hồ Chí Minh</ContactValue>
                  </a>
                </ContactText>
              </ContactItem>
              <ContactItem><ContactIcon><Phone /></ContactIcon>
                <ContactText><ContactLabel>Điện thoại</ContactLabel><ContactValue>096 8694 520</ContactValue></ContactText>
              </ContactItem>
              <ContactItem><ContactIcon><Mail /></ContactIcon>
                <ContactText><ContactLabel>Email</ContactLabel><ContactValue>kmsalon2001@gmail.com</ContactValue></ContactText>
              </ContactItem>
            </ContactDetails>
            <SocialLinks>
              <SocialLink target="_blank" href="https://www.facebook.com/share/1Y366R6Vy1/?mibextid=wwXIfr"><Facebook /></SocialLink>
              <SocialLink target="_blank" href="https://www.instagram.com/kmnailhairsalon"><Instagram /></SocialLink>
            </SocialLinks>
          </ContactInfo>

          <FormContainer>
            <FormTitle>Đặt Lịch Hẹn</FormTitle>
            {status.success && <SuccessMessage>✅ Đã gửi yêu cầu thành công!</SuccessMessage>}
            {status.error && <div style={{color: '#ff4d4d', marginBottom: '1rem'}}>{status.error}</div>}

            <Form onSubmit={handleSubmit}>
              <FormGroup>
                <Label>Họ và tên *</Label>
                <Input type="text" name="name" value={formData.name} onChange={handleChange} required placeholder="Nguyễn Văn A" />
              </FormGroup>
              <FormGroup>
                <Label>Số điện thoại *</Label>
                <Input type="tel" name="phone" value={formData.phone} onChange={handleChange} required placeholder="0901 234 567" />
              </FormGroup>
              <FormGroup>
  <Label htmlFor="datetime">Ngày & Giờ hẹn *</Label>
  <Input
    type="datetime-local"
    id="datetime"
    name="datetime"
    value={formData.datetime}
    onChange={handleChange}
    required
  />
</FormGroup>
              <FormGroup>
                <Label>Dịch vụ *</Label>
                <Select name="service" value={formData.service} onChange={handleChange} required>
                  <option value="">-- Chọn dịch vụ --</option>
                  <option value="Hair Styling">Làm Tóc</option>
                  <option value="Nail Art">Làm Nail</option>
                  <option value="Spa">Spa & Massage</option>
                </Select>
              </FormGroup>
              <FormGroup>
                <Label>Ghi chú</Label>
                <Textarea name="message" value={formData.message} onChange={handleChange} placeholder="Ngày giờ bạn muốn đặt..." />
              </FormGroup>
              <SubmitButton type="submit" disabled={status.loading}>
                {status.loading ? 'Đang gửi...' : 'Gửi Yêu Cầu'}
                {!status.loading && <Send size={20} />}
              </SubmitButton>
            </Form>
          </FormContainer>
        </ContactGrid>
      </Container>
    </SectionWrapper>
  );
};

export default ContactSection;